<template>
  <div class="beta-signup">

    <div v-if="submitted">
      <h2>Thank you!</h2>
      <p>We'll be in touch soon.</p>
    </div>

    <template v-else>
    <h2>{{ label }}</h2>
    <br/>
    <p>
      <input type="text" placeholder="FIRST NAME" v-model="processedForm.firstName" />
    </p>
    <p>
      <input type="text" placeholder="LAST NAME" v-model="processedForm.lastName" />
    </p>
    <p>
      <input type="text" placeholder="EMAIL ADDRESS" v-model="processedForm.email" />
    </p>
    <p>
      <input type="text" placeholder="BUSINESS" v-model="processedForm.businessName" />
    </p>
    <p>
      <input type="text" placeholder="SITE URL" v-model="processedForm.businessUrl" />
    </p>
    <p>
      <input type="text" placeholder="MOBILE" v-model="processedForm.mobile" />
    </p>
    

    <div class="beta-signup-contact-by">
      <h3>Contact Preferences</h3>
      <br/>
      <div class="beta-signup-contact-by-inputs">
        <div class="radio-options">

          <span>
            <input type="radio"
              value="email" 
              id="email"
              v-model="processedForm.contactMethod">
            <label for="email">Email</label>
          </span>

          <span>
            <input type="radio" 
              value="mobile" 
              id="mobile"
              v-model="processedForm.contactMethod">
            <label for="mobile">Mobile</label>
          </span>
          
          <span>
            <input type="radio"
              value="surprise" 
              id="surprise"
              v-model="processedForm.contactMethod">
            <label for="surprise">Surprise Me</label>
          </span>

        </div>

        <p v-if="error" style="color:#f44336;font-size:.875rem;margin:0 0 .5rem;">{{ error }}</p>
        <button
          @click="processForm"
          :disabled="loading">
          {{ loading ? 'SUBMITTING...' : 'Submit' }}
        </button>
      </div>

    </div>

    </template>
  </div>
</template>

<script>
import ServiceGeneral from '@/services/service.general'

export default {
  name: 'BetaSignupForm',
  props: {
    label: {
      type: String,
      default: 'Request'
    }
  },
  data: () => ({
    processedForm: {
      firstName: null,
      lastName: null,
      email: null,
      businessName: null,
      mobile: null,
      contactMethod: 'email',
      businessUrl: null
    },
    error: null,
    loading: false,
    submitted: false
  }),
  methods: {
    validate () {
      const f = this.processedForm
      if (!f.firstName || !f.firstName.trim()) {
        this.error = 'First name is required.'
        return false
      }
      if (!f.lastName || !f.lastName.trim()) {
        this.error = 'Last name is required.'
        return false
      }
      if (!f.email || !f.email.trim()) {
        this.error = 'Email address is required.'
        return false
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.trim())) {
        this.error = 'Please enter a valid email address.'
        return false
      }
      if (f.contactMethod === 'mobile' && (!f.mobile || !f.mobile.trim())) {
        this.error = 'Mobile number is required when mobile contact is selected.'
        return false
      }
      return true
    },
    async processForm () {
      this.error = null
      if (!this.validate()) return
      this.loading = true
      const res = await ServiceGeneral.betaSignup(this.processedForm)
      this.loading = false
      if (res && res.status >= 200 && res.status < 300) {
        this.submitted = true
      } else {
        this.error = 'There was a problem submitting your request. Please try again.'
      }
    }
  }
}
</script>

<style>

</style>